// @ts-nocheck
import { createHandlerChainRunner, Handler, HasOnSuccess } from "@toolkit/Modules/client-framework/HandlerCreator";

type HandlerType = Handler<{ note: string } & HasOnSuccess>;

export const DispatchSetShippingNotes: HandlerType = props => {
    props.dispatch({
        type: "Store/Pages/CheckoutReviewAndSubmit/SetShippingNotes",
        note: props.parameter.note,
    });
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    props.parameter.onSuccess?.();
};
export const chain = [DispatchSetShippingNotes, ExecuteOnSuccessCallback];

const SetShippingNotes = createHandlerChainRunner(chain, "SetShippingNotes");
export default SetShippingNotes;
